import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import { saveParams as saveParamsByNotice } from '../../../actions/noticeActions';
import { saveParams } from '../../../actions/homeActions';

class CrcQualitySheetNews extends Component {
    hide = () => {
        this.props.saveParams({ showCrcQualitySheet: false });
    }

    handleClick = () => {
        const { params, saveParams, saveParamsByNotice } = this.props;
        const { qualitySheetNewsList } = params;
        const { type, userTeacherId } = (qualitySheetNewsList || [])[0];
        saveParams({ showCrcQualitySheet: false });
        saveParamsByNotice({
            type,
            userTeacherId,
        });
        location.href = './#/teaching/qualityAssessmentSheet';
    }

    render() {
        const { params: { showCrcQualitySheet = false, qualitySheetNewsList } } = this.props;
        return (
            <Modal
                title="带教质量评估表填写提醒"
                visible={showCrcQualitySheet}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
                footer={<Button type="primary" onClick={this.handleClick}>前往填写</Button>}
            >
                <div style={{ margin: 10 }}>
                    {
                        (qualitySheetNewsList || []).map(i => (
                            <p key={i.type} style={{marginTop: 10}}>{i.message}</p>
                        ))
                    }
                </div>
            </Modal>
        )
    }
}

const mapSateToProps = (state) => ({
    params: state.homeState.params || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveParamsByNotice: (params) => dispatch(saveParamsByNotice(params)),
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(CrcQualitySheetNews);


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/CrcQualitySheetNews.js